import { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import './SkeletonLoader.css';

export const SkeletonLoader = ({ ...props }) => {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    let t = setTimeout(() => setShowSkeleton(true), 200); // 200ms delay before displaying skeleton loader
    return () => clearTimeout(t);
  }, []);

  const combinedClassName = `${props.className || ''}${showSkeleton ? ' show' : ''}`.trim();
  return <Skeleton {...props} className={combinedClassName} />;
};
